/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../components/Pagination"

const ClsoingStockTable = ({
    ClosingStockList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    ClosingStockCount}) => {
        
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    return(
        <div class=" w-full relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[1px]">
                <div class={`flex px-[6px] ${ClosingStockCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-180px)]'}`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[20%]">
                                    <span >Item Code</span>
                                </th>
                                <th class="w-[20%]">
                                    <span >Item Name</span>
                                </th>
                                <th class="w-[20%]"> 
                                    <span class="flex items-center justify-end">Closing Stock Qty</span>
                                </th>
                                <th class="w-[20%]">
                                    <span class="flex items-center justify-end">Closing Stock Value</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            
                            {ClosingStockList?.map((stock, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group" key={index+stock?._id}>
                                        <td class="text-start" id={'item_code'+index}>{stock?.item_code || '-'}</td>
                                        <td class="text-start" id={'item_name'+index}>{stock?.item_name || '-'}</td>

                                        <td class="text-end" id={'closing_stock_quantity'+index}>{stock?.closing_stock_quantity || '-'}</td>
                                        <td class="text-end" id={'closing_stock_amount'+index}>{parseFloat(stock?.closing_stock_amount).toFixed(2) || '-'}</td>
                                    </tr>
                                </>))}
                        </tbody>
                        
                    </table>
                </div>
            </div> 
            <div className="">              
                {ClosingStockCount > 50 &&  <Pagination
                    TotalCount={ClosingStockCount}
                    limit={50}
                    totalPageNumber={Math?.ceil(ClosingStockCount / 50)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div> 
        </div>
    )
}

export default ClsoingStockTable;